/**
 * 库的信号
 */

export const PYTHA_SINGAL = {
    /**
     * 生成组的零食包围盒的回调
     * 参数1：group对象
     */
    onCreateHelpBoxFinish: "onCreateHelpBoxFinish",
}